export default {
      id: "splash-trim-usage",
      viewBox: "0 0 996 36",
      url: __webpack_public_path__ + "redesign-sprite.svg#splash-trim-usage",
      toString: function () {
        return this.url;
      }
    }